import { omit } from "lodash";

import { Entity } from "@/jenesys-types/data/common";

import {
  ColumnDisplay,
  ColumnOption,
  ColumnOptionWithVisibility
} from "@/components/common/table/types";

export type Accessor<D, ReturnType = any> = keyof D | ((item: D) => ReturnType);

export const getAccessorValue = <D, ReturnType = any>(
  data: D,
  accessor: Accessor<D, ReturnType>
): ReturnType =>
  typeof accessor === "function"
    ? accessor(data)
    : (data[accessor] as ReturnType);

export const getSortedColumnOptionsWithVisibility = (
  columnOptions: Array<ColumnOption>,
  columnDisplay: Array<ColumnDisplay>
): Array<ColumnOptionWithVisibility> =>
  columnDisplay
    .map(({ id, visible }) => {
      const column = columnOptions.find((option) => option.id === id);
      return column ? { ...column, visible } : undefined;
    })
    .filter(Boolean) as Array<ColumnOptionWithVisibility>;

export const ids = (entities: Array<Entity>) => entities.map(({ id }) => id);

// Shallow copies an entity and removes id.
// In the future we'll be able to remove audit fields here etc as well.
// If we ever move them from fast-api only to entity level.
export const cloneEntity = <T extends Entity>(
  entity: T,
  overrides: Partial<T> = {}
) =>
  ({
    ...omit(entity, ["id"]),
    ...overrides
  }) as T;
